export var TranslationsActionTypes;
(function (TranslationsActionTypes) {
    TranslationsActionTypes["FETCH_TRANSLATION_ATTEMPT"] = "FETCH_TRANSLATION_ATTEMPT";
    TranslationsActionTypes["FETCH_TRANSLATION_SUCCESS"] = "FETCH_TRANSLATION_SUCCESS";
    TranslationsActionTypes["FETCH_TRANSLATION_FAILURE"] = "FETCH_TRANSLATION_FAILURE";
})(TranslationsActionTypes || (TranslationsActionTypes = {}));
